import { Analysis, AnalysisStatus } from '../interfaces';

export function getAnalysisStatus(analysis: Analysis): AnalysisStatus {
	if (analysis.purgedAt || analysis.deletedAt) return 'deleted';

	const now = Date.now();
	if (now > analysis.expiresAt.toMillis()) return 'expired';
	if (analysis.processedAt) return 'ready';
	if (analysis.erroredAt) return 'error';

	return 'uploading';
}

/**
 * `_tags` exclusions so Algolia lists omit analyses already indexed as
 * deleted or expired. Stale `ready` records that have since passed
 * `expiresAt` are dropped with {@link activeAnalysisAlgoliaFilters}.
 */
export const HiddenAnalysisAlgoliaStatusTags = [
	'-status:deleted',
	'-status:expired',
] as const;

/**
 * Numeric Algolia filter that keeps analyses whose `expiresAt` is still in
 * the future. Combined with existing `filters` when present.
 */
export function activeAnalysisAlgoliaFilters(
	now = Date.now(),
	existing?: string,
): string {
	const expiry = `expiresAt > ${now}`;
	return existing ? `(${existing}) AND ${expiry}` : expiry;
}

export function activeAnalysisAlgoliaTagFilters<T>(
	existing: readonly T[] = [],
): Array<T | (typeof HiddenAnalysisAlgoliaStatusTags)[number]> {
	return [...existing, ...HiddenAnalysisAlgoliaStatusTags];
}
